import { Component, OnInit, Input } from "@angular/core";
import { GenericListConfig } from "@app/shared/models/GenericList/GenericList";
import {
    GenericListManagerComponent,
    GENERIC_LIST_MANAGER_SCOPE,
} from "@app/shared/generic-managers/generic-list-manager/generic-list-manager.component";
import { Observable } from "rxjs";
import { provideTranslocoScope } from "@jsverse/transloco";

@Component({
    selector: "expandable-list",
    templateUrl: "./expandable-list.component.html",
    styleUrls: ["./expandable-list.component.scss"],
    standalone: false,
    providers: [
        provideTranslocoScope({
            scope: GENERIC_LIST_MANAGER_SCOPE,
            alias: "genericListManager",
        }),
    ],
})
export class ExpandableListComponent extends GenericListManagerComponent implements OnInit {
    @Input() config: GenericListConfig;
    @Input() innerConfig: GenericListConfig;
    @Input() innerConfigDataMethod: (guid: string) => Observable<any>;
    @Input() colSpan: number;

    activeRow: any;
    scopedTableData: any[];
    scopedTableExpanded = false;
    scopedToggleAllowed = false;

    ngOnInit() {
        this.config.reload = async () => {
            this.tableData = null;
            this.baseConfig = this.config;
            await this.loadPage();
        };

        this.baseConfig = this.config;
        this.editor = this.editorCmp;

        this.loadPage();
    }

    triggerClick(row: any) {
        this.activeRow = row;
    }

    toggleScopedTableData() {
        this.scopedTableExpanded = !this.scopedTableExpanded;
        this.setScopedTable();
    }

    setScopedTable() {
        this.scopedToggleAllowed =
            this.config.limitViewTo > 0 &&
            !this.config.isSortable &&
            this.tableData.length > this.config.limitViewTo;

        if (this.scopedToggleAllowed && !this.scopedTableExpanded) {
            this.scopedTableData = this.searchedTableData.slice(0, this.config.limitViewTo);
        } else {
            this.scopedTableData = this.searchedTableData;
        }

        this.config._visibleRowCount = this.searchedTableData.length;
    }

    getLinkedIds(row) {
        this.scopedTableData.filter((a) => a !== row).forEach((x) => (x.showEditor = false));
        this.innerConfig.dataMethod = () => this.innerConfigDataMethod(row.Guid ?? row.guid);

        if (this.innerConfig.reload) {
            this.innerConfig.reload();
        }
    }
}
